import React from "react";
import { useTranslation } from "react-i18next";
import ContactForm from "./ContactForm";
import Seo from "./Seo";

interface ContactProps {
  lang: "de" | "en";
}

const Contact: React.FC<ContactProps> = ({ lang }) => {
  const { t } = useTranslation();

  return (
    <>
      <Seo
        lang={lang}
        path="/contact"
        title={t("seo.contactTitle")}
        description={t("seo.contactDescription")}
      />
      <ContactForm />
    </>
  );
};

export default Contact;
